import React from "react";
import { Container, Title, Text, Stack, Box } from "@mantine/core";
import babyStork from "../img/stork-carrying-baby-cropped.jpg";
import babyStorkMd from "../img/stork-carrying-baby-cropped-md.jpg";
import babyStorkSm from "../img/stork-carrying-baby-cropped-sm.jpg";
import babyStorkXs from "../img/stork-carrying-baby-cropped-xs.jpg";
import { Tabs } from "./Tabs";
import { useViewportSize } from "@mantine/hooks";

interface IHeaderProps {
  activeTab: string | null;
  onTabChange?: (tab: string | null) => void;
}
const Header = ({ activeTab, onTabChange }: IHeaderProps) => {
  const { width } = useViewportSize();
  const babyStorkImage = width < 688 ? width < 490 ? width < 380 ? babyStorkXs : babyStorkSm : babyStorkMd : babyStork;
  return (
    <Box
      style={{
        position: "relative",
        backgroundImage: `linear-gradient(to bottom, rgba(0, 0, 0, 0.1), rgba(0, 0, 0, 0.2)), url(${babyStorkImage})`, // Gradient + image
        //backgroundSize: "cover",
        backgroundRepeat: "no-repeat", // Prevents the image from repeating
        backgroundPosition: "top",
        //height: "410px",
      }}
    >

      {/* Content */}
      <Container
        size="lg"
        style={{
          position: "relative",
          zIndex: 2,
          height: "100%",
          minHeight: "410px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          alignItems: "center",
          textAlign: "center",
          paddingBottom: "20px"
        }}
      >
        <Stack gap="xs">
          <Title order={1} size="h1" c="white" fw={700}>
            Sarah Taggart & Nicholas Hendrickson
          </Title>
          <Text size="md" c="white" fw={700}>
            INDIE'S REGISTRY
          </Text>
          <Text size="sm" c="white" fw={700}>
            SATURDAY, JANUARY 11, 2025
          </Text>
        </Stack>
      </Container>
      <Tabs activeTab={activeTab} onTabChange={onTabChange} />
    </Box>
  );
};

export default Header;
